export default {
  addProject: {
    appUrl: 'ストアリンク',
    appUrlPlaceholder: '製品のアプリストアリンクを入力してください',
    invalidLinkFormat: 'リンク形式が正しくありません',
    languages: '対象言語',
    ratios: '画像サイズ',
    submit: '作成',
  },
  projectList: {
    table: {
      languages: '言語',
      ratios: 'サイズ',
    },
  },
}
